import { render } from "./HighlightedArticles.vue?vue&type=template&id=6804712d"
import script from "./HighlightedArticles.vue?vue&type=script&lang=js"
export * from "./HighlightedArticles.vue?vue&type=script&lang=js"

import exportComponent from "/Users/matteomelillo/Dev/wpHeadless/suisseconsulences.ch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__